import styles from "./Title.module.css";

type TitleProps = {
  text: string;
  size: number;
  color?: string;
};


export const Title = ({ text, size, color }: TitleProps) => {
  const style: React.CSSProperties = {
    fontSize: `${size}px`,
    ...(color && { color }),
  };

  return (
    <div className={styles.text} style={style}>
      {text}
    </div>
  );
};
